import { Layout, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import {
  DashboardOutlined,
  ShoppingOutlined,
  UserOutlined,
  SettingOutlined,
  BarChartOutlined,
  MessageOutlined,
  WarningOutlined,
  SendOutlined
} from '@ant-design/icons';

const { Sider } = Layout;

export const Sidebar: React.FC = () => {
  const location = useLocation();

  const menuItems = [
    {
      key: '/',
      icon: <DashboardOutlined />,
      label: <Link to="/">Головна</Link>
    },
    {
      key: '/orders',
      icon: <ShoppingOutlined />,
      label: <Link to="/orders">Замовлення</Link>
    },
    {
      key: '/conversations',
      icon: <MessageOutlined />,
      label: <Link to="/conversations">Переписки</Link>
    },
    {
      key: '/telegram',
      icon: <SendOutlined />,
      label: <Link to="/telegram">Telegram</Link>
    },
    {
      key: '/dlq',
      icon: <WarningOutlined />,
      label: <Link to="/dlq">DLQ</Link>
    },
    {
      key: '/clients',
      icon: <UserOutlined />,
      label: <Link to="/clients">Клієнти</Link>
    },
    {
      key: '/analytics',
      icon: <BarChartOutlined />,
      label: <Link to="/analytics">Аналітика</Link>
    },
    {
      key: '/settings',
      icon: <SettingOutlined />,
      label: <Link to="/settings">Налаштування</Link>
    }
  ];

  return (
    <Sider
      width={250}
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0
      }}
    >
      <div
        style={{
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 20,
          fontWeight: 'bold',
          color: '#fff'
        }}
      >
        🎵 Kompozitor
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        items={menuItems}
      />
    </Sider>
  );
};
